















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Icon } from 'vant';

@Component({
  name: 'HeaderNav',
  components: {
    [Icon.name]: Icon,
  }
})
export default class HeaderNav extends Vue {
  @Prop({
    type: String,
    default: ''
  }) title!: string;

  path = '';

  get isShowBackBtn() {
    const noBackRouteList = ['/', '/jd/activity', '/register-success'];

    return !noBackRouteList.includes(this.path);
  }

  @Watch('$route')
  public onRouteChanged() {
    this.path = this.$route.path;
  }

  mounted() {
    this.path = this.$route.path;
  }

  // 返回上一页
  goBack() {
    history.go(-1);
  }
}
